import React from 'react';
import MEDIUM_PLANT from '../../utils/assets/png/How-Revenu-sharing-works.png';

const RevenueSharing = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#fefefc',
        width: '100%',
        boxSizing: 'border-box',
        padding: '0 16px',
        overflowX: 'hidden',
        borderTop: '1px solid black',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontFamily: 'Segoe UI',
          fontSize: 'clamp(26px, 6vw, 45px)',
          fontWeight: 600,
          lineHeight: 1.2,
          color: 'rgb(27, 22, 66)',
          marginTop: '25px',
        }}
      >
        How Revenue Sharing Works
      </div>
      <div
        style={{
          fontFamily: 'Roboto Italic',
          fontSize: 'clamp(14px, 3.8vw, 16px)',
          color: '#1B1642',
          marginBottom: '10px',
          marginTop: '5px',
        }}
      >
        More customers you invite, more revenue you earn — no limits.
      </div>
      <div
        style={{
          color: '#1B1642',
          fontFamily: 'Segoe UI',
          fontSize: 'clamp(16px, 4vw, 20px)',
          lineHeight: 1.5,
          textAlign: 'center',
          maxWidth: '830px',
          marginTop: '10px',
        }}
      >
        We share revenue with you when you invite new customers to our platform. With just around
        5,000 invited customers, you could earn an estimated{' '}
        <span style={{ color: '#4ee31cff', fontWeight: 600 }}> $4,000 per month</span> — even if
        each customer orders just one meal a month.
      </div>

      <img
        alt=''
        src={MEDIUM_PLANT}
        style={{
          width: '100%',
          maxWidth: '800px',
          height: 'auto',
          margin: 'clamp(16px, 4vw, 28px) 0 clamp(48px, 10vw, 100px)',
        }}
      />
    </div>
  );
};

export default RevenueSharing;
